export default __webpack_public_path__ + "static/media/Logo-Hymix-09-07-58-077.6e74499e.svg";